import { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import AppNavbar from "../../Navbar/AppNavbar";
import Footer from "../../Navbar/Footer";
import saveImg from "../../../assets/images/searchContact/saveImgWhite.svg";
import "../../../assets/css/search.scss";
import EditSavedSearchModal from "./EditSavedSearchModal";
import DeleteSavedSearchConfirmModal from "./DeleteSavedSearchConfirmModal";
import { useDispatch, useSelector } from "react-redux";
import { loadSavedSearches, updateSavedSearchData } from "../../redux/action";
import CryptoJS from "crypto-js";
import { useNavigate } from "react-router-dom";

const SavedSearches = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const signInDetails = JSON.parse(sessionStorage.getItem("SignInDetails"));
    const signInID = signInDetails[0]?.id;
    const sbnID = signInDetails[0]?.sbn_id;
    const { savedSearchData } = useSelector((state) => state.data);

    const [openMenuIndex, setOpenMenuIndex] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedIndexToDelete, setSelectedIndexToDelete] = useState(null);
    const [loading, setLoading] = useState(false);
    const [selectedSearch, setSelectedSearch] = useState(null);

    const handleMenuToggle = (index) => {
        setOpenMenuIndex(openMenuIndex === index ? null : index);
    };

    const handleOpenEdit = (item) => {
        setSelectedSearch(item);
        setShowEditModal(true);
        setOpenMenuIndex(null);
    };

    const handleDeleteClick = (item) => {
        setSelectedSearch(item);
        setShowDeleteModal(true);
    };

    const fetchSavedSearches = () => {
        dispatch(loadSavedSearches(signInID, sbnID, setLoading));
    }

    useEffect(() => {
        fetchSavedSearches()
    }, [dispatch, signInID, sbnID]);


    const handleView = (item) => {
        const secret = "lm_data_param"; // Should be stored securely 
        const payload = {
            ...(typeof item.search_data === "object" && item.search_data
                ? item.search_data
                : { query: item.search_data }),
            
            provider: (
                item.provider ||
                item.PROVIDER ||
                item.search_data?.provider ||
                null
            ),
        };
        const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(item.search_data), secret).toString();
        navigate(`/contact-filter?data=${encodeURIComponent(ciphertext)}`);
    }

    return (
        <div className="page-layout">
            <AppNavbar />
            <div className="page-content">
                <div className="saved-search-container">
                    <div className="saved-search-header-container">
                        <div className="saved-search-header-div">
                            <p>Saved</p>
                            <div className="saved-search-img-div">
                                <h5>Searches</h5>
                                <img src={saveImg} alt="Save" />
                            </div>
                        </div>
                    </div>
                    <div className="saved-searches-body">
                        <Row className="m-0 saved-searches-card-row">
                            {savedSearchData.length > 0 ? (
                                savedSearchData.map((item, index) => (
                                    <Col
                                        md={3}
                                        sm={6}
                                        xs={12}
                                        className="saved-searches-card-col mb-4"
                                        key={index}
                                    >
                                        <Card
                                            className="modern-saved-card h-100"
                                            onClick={() => handleView(item)}
                                        >
                                            {/* Top Gradient Accent */}
                                            <div className="saved-card-accent"></div>

                                            <Card.Body className="modern-saved-card-body">

                                                {/* Card Header */}
                                                <div className="saved-card-header">

                                                    {/* Search Icon */}
                                                    <div className="saved-search-icon">
                                                        <i className="fa-solid fa-magnifying-glass"></i>
                                                    </div>

                                                    {/* Search Name */}
                                                    <div className="saved-search-info">
                                                        <Card.Title className="saved-card-title">
                                                            {item.saved_search_name}
                                                        </Card.Title>

                                                        <div className="saved-card-label">
                                                            <span className="status-dot"></span>
                                                            Saved Search
                                                        </div>
                                                    </div>

                                                    {/* Three Dot Menu */}
                                                    <div className="saved-card-menu">

                                                        <button
                                                            type="button"
                                                            className="saved-menu-button"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleMenuToggle(index);
                                                            }}
                                                        >
                                                            <i className="fa-solid fa-ellipsis-vertical"></i>
                                                        </button>

                                                        {openMenuIndex === index && (
                                                            <div className="dropdown-card-options modern-saved-dropdown">

                                                                <div
                                                                    className="dropdown-item modern-dropdown-item"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        handleOpenEdit(item);
                                                                    }}
                                                                >
                                                                    <i className="fa-solid fa-pen-to-square"></i>
                                                                    <span>Edit</span>
                                                                </div>

                                                                <div
                                                                    className="dropdown-item modern-dropdown-item delete-dropdown-item"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        handleDeleteClick(item);
                                                                    }}
                                                                >
                                                                    <i className="fa-solid fa-trash"></i>
                                                                    <span>Delete</span>
                                                                </div>

                                                            </div>
                                                        )}

                                                    </div>

                                                </div>

                                                {/* Divider */}
                                                <div className="saved-card-divider"></div>

                                                {/* Date & Time */}
                                                <div className="saved-card-details">

                                                    <div className="saved-detail-box">

                                                        <div className="saved-detail-icon">
                                                            <i className="fa-regular fa-calendar"></i>
                                                        </div>

                                                        <div className="saved-detail-content">
                                                            <span className="saved-detail-label">
                                                                Date
                                                            </span>

                                                            <span className="saved-detail-value">
                                                                {new Date(
                                                                    item.date_time
                                                                ).toLocaleDateString()}
                                                            </span>
                                                        </div>

                                                    </div>

                                                    <div className="saved-detail-box">

                                                        <div className="saved-detail-icon">
                                                            <i className="fa-regular fa-clock"></i>
                                                        </div>

                                                        <div className="saved-detail-content">
                                                            <span className="saved-detail-label">
                                                                Time
                                                            </span>

                                                            <span className="saved-detail-value">
                                                                {new Date(
                                                                    item.date_time
                                                                ).toLocaleTimeString([], {
                                                                    hour: "2-digit",
                                                                    minute: "2-digit"
                                                                })}
                                                            </span>
                                                        </div>

                                                    </div>

                                                </div>

                                                {/* Bottom Action */}
                                                <div className="saved-card-footer">

                                                    <span className="saved-view-text">
                                                        Open saved search
                                                    </span>

                                                    <div className="saved-view-arrow">
                                                        <i className="fa-solid fa-arrow-right"></i>
                                                    </div>

                                                </div>

                                            </Card.Body>
                                        </Card>
                                    </Col>
                                ))
                            ) : (
                                <p>No saved searches available</p>
                            )}
                        </Row>
                    </div>
                </div>

                {/* Modal Component (UI only) */}
                <EditSavedSearchModal
                    show={showEditModal}
                    onHide={() => setShowEditModal(false)}
                    updateSavedSearchData={updateSavedSearchData}
                    selectedSearch={selectedSearch}
                    fetchSavedSearches={fetchSavedSearches}
                />
                <DeleteSavedSearchConfirmModal
                    show={showDeleteModal}
                    onHide={() => setShowDeleteModal(false)}
                    selectedSearch={selectedSearch}
                    fetchSavedSearches={fetchSavedSearches}
                />
            </div>
            <Footer />
        </div>
    );
};

export default SavedSearches;
